// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

/**
 * How a stargate's device api_key is shown.
 * Absent field: the caller is not an admin and the key was omitted.
 * Present null or empty: an admin, and the device has no key yet.
 */
export function stargateApiKeyText(stargate) {
  if (!stargate || !Object.prototype.hasOwnProperty.call(stargate, 'api_key')) {
    return 'Restricted';
  }
  return stargate.api_key ? stargate.api_key : 'Not set';
}

/** Edit control: admin, and the response actually included the field. */
export function stargateApiKeyEditable(stargate, isAdmin) {
  return (
    Boolean(isAdmin) &&
    Boolean(stargate) &&
    Object.prototype.hasOwnProperty.call(stargate, 'api_key')
  );
}
